export const CURRENCIES = [
  { code: "NONE", symbol: "", label: "No currency" },
  { code: "INR", symbol: "₹", label: "₹ INR - Indian Rupee" },
  { code: "USD", symbol: "$", label: "$ USD - US Dollar" },
  { code: "EUR", symbol: "€", label: "€ EUR - Euro" },
  { code: "GBP", symbol: "£", label: "£ GBP - British Pound" },
  { code: "SAR", symbol: "﷼", label: "﷼ SAR - Saudi Riyal" },
  { code: "AED", symbol: "د.إ", label: "د.إ AED - UAE Dirham" },
];

export const getCurrencySymbol = (code) => {
  const c = CURRENCIES.find((c) => c.code === code);
  return c ? c.symbol : "";
};

export const formatCurrency = (amount, currencyCode = "INR") => {
  if (amount === undefined || amount === null) return getCurrencySymbol(currencyCode) + "0";
  const symbol = getCurrencySymbol(currencyCode);
  return symbol + Number(amount).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};
